(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractDialogController', AgentSupplierContractDialogController);

    AgentSupplierContractDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentSupplierContract', 'AgentAccessInfo', 'AgentRequest', 'Company'];

    function AgentSupplierContractDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentSupplierContract, AgentAccessInfo, AgentRequest, Company) {
        var vm = this;

        vm.agentSupplierContract = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.agentaccessinfos = AgentAccessInfo.query();
        vm.agentrequests = AgentRequest.query();
        vm.companies = Company.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentSupplierContract.id !== null) {
                AgentSupplierContract.update(vm.agentSupplierContract, onSaveSuccess, onSaveError);
            } else {
                AgentSupplierContract.save(vm.agentSupplierContract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentSupplierContractUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
